import React, { useCallback, useEffect, useState } from 'react';
import { withRouter } from 'react-router-dom';
import {
  XAxis, YAxis, CartesianGrid, Tooltip, BarChart,
  Bar,
  Rectangle,
  PieChart,
  Pie,
} from 'recharts';
import SearchIcon from '@material-ui/icons/Search';
import { IconButton } from '@material-ui/core';
import { toast } from 'react-toastify';
import { getCurrentIdUsuario, getMoneyMask } from '../../../helpers';
import { findResumoMensal, findUsuariosPermitidos } from '../../../services/core/controleBordero/controleBordero.service';
import Grid24 from '../../../components/UI/Grid24';
import DateField from '../../../components/UI/Field/Date/DateField';
import useStyle, {
  CardTop, ContainerPrincipal, ResumoContainer, WrapperFormWithTitle,
} from './ResumoMensalStyles';
import TabelaFiliais from './TabelaFiliais';
import SelectorModel from '../../../models/SelectorModel';


function ResumoMensalComponent() {
  const styles = useStyle();

  const [dataInicial, setDataInicial] = useState('');
  const [dataFinal, setDataFinal] = useState('');
  const [resumoMensal, setResumoMensal] = useState([]);
  const [usuarios, setUsuarios] = useState([]);

  useEffect(() => {
    if (usuarios.length === 0) {
      findUsuariosPermitidos(getCurrentIdUsuario()).then((response) => {
        const resposta = response.data.map(usuario => (new SelectorModel(usuario.idUsuario, usuario.nomeUsuario)));
        setUsuarios(resposta);
      });
    }
  },
  [usuarios]);

  const onSubmitHandler = useCallback(() => {
    findResumoMensal(dataInicial, dataFinal).then((response) => {
      setResumoMensal(response.data);
      if (response.data.length === 0) {
        toast.warn('Nenhum resultado foi encontrado relacionado à sua pesquisa');
      }
    });
  }, [dataInicial, dataFinal]);

  return (
    <ContainerPrincipal>
      <Grid24 item xs={24} sm={16} style={{ margin: '5px' }}>
        <div style={{ margin: '5px' }}>
          <DateField
            isForm
            disabled={usuarios.length === 0}
            label="Data Inicial"
            name="Data Inicial"
            value={dataInicial}
            onChange={e => setDataInicial(e.target.value)}
          />
        </div>
        <div style={{ margin: '5px' }}>
          <DateField
            isForm
            disabled={usuarios.length === 0}
            label="Data Final"
            name="Data Final"
            value={dataFinal}
            onChange={e => setDataFinal(e.target.value)}
          />
        </div>
        <div style={{ marginTop: 'auto' }}>
          <IconButton
            onClick={onSubmitHandler}
            disabled={dataInicial === '' || dataFinal === ''}
            type="submit"
            className={styles.button}
          >
            <SearchIcon />
          </IconButton>
        </div>
      </Grid24>
      <Grid24 item xs={24} sm={21} style={{ margin: '10px' }}>
        <ResumoContainer>
          <p className="title">Resumo</p>
          <div>
            <CardTop color="#a3a1a3">
              <p>Número Total de Processos</p>
              <p>{resumoMensal.reduce((acc, item) => acc + item.qtdeProcessos, 0)}</p>
            </CardTop>
            <CardTop color="#a3a1a3">
              <p>Número Total de Clientes Novos</p>
              <p>
                {resumoMensal.reduce((acc, item) => acc + item.totalClientesNovos, 0)}
              </p>
            </CardTop>
            <CardTop color="#a3a1a3">
              <p>Total Geral</p>
              <p>{getMoneyMask(resumoMensal.reduce((acc, item) => acc + item.totalProcesso, 0))}</p>
            </CardTop>
          </div>
        </ResumoContainer>
      </Grid24>

      <Grid24 item xs={24} sm={24} style={{ margin: '5px', flexDirection: 'column' }}>
        <div style={{ width: '950px' }}>
          <WrapperFormWithTitle title="Filiais">
            <TabelaFiliais
              content={resumoMensal}
            />
          </WrapperFormWithTitle>
        </div>

        <div style={{ width: '950px' }}>
          <WrapperFormWithTitle title="Quantidade de Processos por Filial">
            <BarChart
              width={900}
              height={400}
              data={resumoMensal}
            >
              <CartesianGrid strokeDasharray="3 3" />
              <XAxis dataKey="nomeFilial" />
              <YAxis />
              <Tooltip formatter={value => [`Quantidade: ${value}`]} />
              <Bar type="monotone" dataKey="qtdeProcessos" fill="#8884d8" activeBar={<Rectangle fill="pink" stroke="blue" />} />
            </BarChart>
          </WrapperFormWithTitle>
        </div>

        <div style={{ width: '950px' }}>
          <WrapperFormWithTitle title="Total de Processos por Filial">
            <PieChart
              width={900}
              height={400}
            >
              <Pie
                dataKey="totalProcesso"
                data={resumoMensal}
                fill="#8884d8"
                cx="50%"
                cy="50%"
                activeShape={{
                  fill: 'pink',
                  stroke: 'blue',
                }}
                labelLine={false}
                label={({
                  cx, cy, midAngle, outerRadius, index,
                }) => {
                  const RADIAN = Math.PI / 180;
                  const x = cx + (outerRadius + 30) * Math.cos(-midAngle * RADIAN);
                  const y = cy + (outerRadius + 30) * Math.sin(-midAngle * RADIAN);

                  return (
                    <text x={x} y={y} fill="black" textAnchor="middle" dominantBaseline="center">
                      {midAngle < 358 ? resumoMensal[index].nomeFilial : ''}
                    </text>
                  );
                }
              }
              />
              <Tooltip
                formatter={(value, index) => [`${getMoneyMask(value)}`, `${resumoMensal[index].nomeFilial}`]}
              />
            </PieChart>
          </WrapperFormWithTitle>
        </div>
      </Grid24>
    </ContainerPrincipal>
  );
}

export const ResumoMensal = withRouter(ResumoMensalComponent);
